import React from "react";
import Helmet from "react-helmet";
import PropTypes from "prop-types";
import Accordion from "../../shared/accordion";
import ArrowIcon from "../../shared/arrow";
import { NUMBER } from "../../../constants/app-constants";
import styles from "./styles.css";
import useStyleInjection from "../../../hooks/use-style-injection";

const CarListingFaq = ({ faqData }) => {
    const accordionData = faqData || [];
    const { getOrCreateRef, injectStyles } = useStyleInjection();

    const renderHyperLinks = (answerObject) => {
        const _answerObject = answerObject || {};
        let answerText = _answerObject.text;
        if (!_answerObject.hyperlinks) {
            return (answerText);
        } else {
            (Object.keys(_answerObject.hyperlinks).map(key => {
                const updatedAnswerTest = answerText.replace(key, `<a href=${_answerObject.hyperlinks[key]} target="_blank">${key}</a>`);
                answerText = updatedAnswerTest;
            }));
        }
        return answerText;
    };

    const handleAccordionClick = async (onClick, index, question) => {
        const cleanup = injectStyles(question);

        try {
            await onClick({ index });
        } finally {
            // eslint-disable-next-line no-unused-expressions
            cleanup?.();
        }
    };

    if (accordionData.length <= NUMBER.ZERO) {
        return null;
    }

    const faqSchema = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity":
            faqData.map((faq) => {
                return ({
                    "@type": "Question",
                    "name": faq.question,
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": renderHyperLinks(faq.answer)
                    }
                });
            })
    });

    return (
        <React.Fragment>
            <Helmet script={[
                {
                    type: "application/ld+json",
                    innerHTML: faqSchema
                }
            ]} />
            <div styleName={"styles.outer"}>
                <div styleName={"styles.contentWraps"}>
                    {accordionData.map(({ question, answer }, index) => (
                        <Accordion key={question} toggleAll={true} totalItems={accordionData.length} collapseAccordion={true}>
                            {({ onClick, currentVisibleStates }) => (
                                <div
                                    ref={getOrCreateRef(question)}
                                    styleName={"styles.borders"}
                                    onClick={() => handleAccordionClick(onClick, index, question)}
                                >
                                    <Accordion.Content>
                                        <Accordion.Heading>
                                            <h4 styleName={"styles.subheadings"}>
                                                {question}
                                                <span>
                                                    <ArrowIcon
                                                        black="BlackArrow"
                                                        rotateBy={currentVisibleStates[index] ? 0 : NUMBER.ONE_HUNDRED_EIGHTY}
                                                    />
                                                </span>
                                            </h4>
                                        </Accordion.Heading>
                                        <Accordion.Body>
                                            <div styleName={currentVisibleStates[index] ? "styles.hideBody" : "styles.showBody"}>
                                                <p
                                                    styleName={"styles.heading-texts"}
                                                    dangerouslySetInnerHTML={{
                                                        __html: renderHyperLinks(answer)
                                                    }}
                                                />
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Content>
                                </div>
                            )}
                        </Accordion>
                    ))}
                </div>
            </div>
        </React.Fragment>
    );
};

CarListingFaq.propTypes = {
    content: PropTypes.object,
    fetchFaqConnect: PropTypes.func,
    selectedCityCode: PropTypes.number,
    selectedFilters: PropTypes.array,
    allFilters: PropTypes.object,
    urlOptions: PropTypes.object,
    isSSR: PropTypes.bool,
    appliedFilters: PropTypes.array,
    faqData: PropTypes.array
};

export default CarListingFaq;
